import styled from 'styled-components';

import {
  ThemeProps as Prop, FontFamily, FontSize,
  Components,
} from '@powdr/constants';
import { getFontStyles, rgbaTransparencyToHex, themeUtil } from '@powdr/utils';

const CPNT = Components.FORM_TRIPLESEAT;

export const StyledFormTripleseat = styled.div`
  width: 100%;

  table {
    width: 100%;
  }

  label {
    margin-bottom: 7px;
  }

  input.text, input.hasDatepicker, textarea, select, option, input.timeselect_input, .tripleseat-dlf-input {
    display: block;
    height: auto;
    width: 100%;
    padding: 10px 15px;
    ${() => getFontStyles(FontFamily.BASE_FONT, FontSize.REG50, undefined, undefined)};
    line-height: 1.25;
    color: #55595c;
    background-color: white;
    background-image: none;
    background-clip: padding-box;
    border: 1px solid rgba(0,0,0,.15) !important;
    margin-bottom: 15px;
  }

  select {
    width: auto;
  }

  td[align="right"] {
    text-align: right;
  }

  .tripleseat-dlf-heading {
    color: ${({ $colorProfile, $component }) => themeUtil(Prop.HEADER, $component, $colorProfile)} !important;
  }
  
  .tripleseat-dlf-input {
    border-radius: 0;
    margin-bottom: 0;
  }

  .tripleseat-dlf-heading, .tripleseat-dlf-text {
    margin-bottom: 15px;
  }

  .tripleseat-dlf-field-group {
    margin-bottom: 15px;
    margin-top: 15px;
  }

  .tripleseat-dlf-checkbox-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .tripleseat-dlf-checkbox-label {
    padding: 0 !important;
    margin-bottom: 0;
    color: ${({ $colorProfile, $component }) => themeUtil(Prop.CONTENT, $component, $colorProfile)} !important;
  }

  .tripleseat-dlf-label {
    color: ${({ $colorProfile, $component }) => themeUtil(Prop.CONTENT, $component, $colorProfile)}  !important;
  }

  .tripleseat-dlf-help-text {
    color: ${({ $colorProfile, $component }) => themeUtil(Prop.CONTENT, $component, $colorProfile) + rgbaTransparencyToHex(75 / 100)} !important;
    ${({ $component }) => getFontStyles(FontFamily.BASE_FONT, FontSize.REG40, undefined, undefined, $component, 'small')};
  }

  tr.row_phone_number, tr.row_booking_rooms_per_night, tr.row_submit {
    display: flex;

    td input#lead_phone_number {
      width: auto;
      min-width: 200px !important;
    }

    td.extension input {
      width: 5%;
      min-width: 100px !important;
    }

    td input#lead_booking_rooms_per_night {
      width: auto;
    }

    td#lead_form_submit {
      display: flex;
      width: 50%;
      gap: 2%;
      align-items: center;
    }
  }

  tr.row_booking_date, tr.row_first_name, tr.row_time {
    display: flex;
    width: 100%;

    td {
      width: 50%;
    }
  }

  input[type='checkbox'] {
    display: grid;
    cursor: pointer;
    place-content: center;
    appearance: none;
    margin: 0;
    width: 2em;
    height: 2em;
    background-color: ${({ $colorProfile }) => themeUtil(Prop.BACKGROUND, CPNT, $colorProfile)} !important;
    border: 2px solid ${({ $colorProfile }) => themeUtil(Prop.CONTENT, CPNT, $colorProfile)} !important;
    ${({ $roundedToggle }) => ($roundedToggle) && 'border-radius: 4px;'};
    margin-right: 5px;
  }

  input[type="checkbox"]::before {
    content: "";
    width: 1.25em;
    height: 1.25em;
    transform: scale(0);
    box-shadow: inset 1em 1em ${({ $colorProfile }) => themeUtil(Prop.CONTENT, CPNT, $colorProfile)} !important;
    transform-origin: bottom left;
    clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
  }

  input[type="checkbox"]:checked::before {
    transform: scale(1);
  }

  input[type="checkbox"]:focus {
    outline: max(2px, 0.15em) solid ${({ $colorProfile }) => themeUtil(Prop.CONTENT, CPNT, $colorProfile)};
    outline-offset: max(2px, 0.15em);
  }

  &:hover {
    input[type='checkbox']:before {
      background-color: ${({ $colorProfile }) => themeUtil(Prop.BTN_BG_ACTIVE, CPNT, $colorProfile)};
    }
  }

  input[type='checkbox']:checked:before {
    background-color: ${({ $colorProfile }) => themeUtil(Prop.BTN_BG_ACTIVE, CPNT, $colorProfile)};
  }

  td:has(input.checkbox) {
    display: flex;
    align-items: center;

    label {
      margin-bottom: 0;
    }
  }

  a:not(.btn), a:not(.btn) > small {
    transition: color .25s ease-out, background-color .25s ease-out;
    color: ${({ $colorProfile, $component }) => themeUtil(Prop.LINK_TXT, $component, $colorProfile)};

    &:hover, &:focus {
      transition: color .25s ease-out, background-color .25s ease-out;
      color: ${({ $colorProfile, $component }) => themeUtil(Prop.LINK_TXT_HOVER, $component, $colorProfile)};
    }

    &:focus {
      outline: 2px solid ${({ $colorProfile, $component }) => themeUtil(Prop.LINK_TXT_HOVER, $component, $colorProfile)};
      outline-offset: 2px;
    }
  }

  .add_event.button, #lead_submit.button, .delete_event, .tripleseat-dlf-submit {
    ${({ $component }) => getFontStyles(FontFamily.SECONDARY_FONT, undefined, undefined, undefined, $component, 'button')};
    line-height: 1;
    border: none;
    cursor: pointer;
    display: inline-block;
    position: relative;
    text-align: center;
    width: auto;
    height: auto;
    padding: 16px 20px;
    text-transform: none;
    margin: 0;
    color: ${({ $colorProfile, $component }) => themeUtil(Prop.BTN_TXT, $component, $colorProfile)} !important;
    background-color: ${({ $colorProfile, $component }) => themeUtil(Prop.BTN_BG, $component, $colorProfile)};
    transition: color .25s ease-out, background-color .25s ease-out;
    border: none !important;

    &:hover, &:focus {
      transition: color .25s ease-out, background-color .25s ease-out;
      color: ${({ $colorProfile, $component }) => themeUtil(Prop.BTN_TXT_HOVER, $component, $colorProfile)};
      background-color: ${({ $colorProfile, $component }) => themeUtil(Prop.BTN_BG_HOVER, $component, $colorProfile)};
    }

    &:focus {
      outline: 2px solid ${({ $colorProfile, $component }) => themeUtil(Prop.BTN_BG_HOVER, $component, $colorProfile)};
      outline-offset: 2px;
    }
  }

  #tripleseat_embed_form .button {
    float: unset !important;
    font-size: unset;
  }
`;
